import { themesMixin } from '../../../utils/themes';
import { mapsMixin } from '../../../utils/maps';
export default {
  name: 'CoreChartAlarmTable',
  mixins: [mapsMixin, themesMixin],
  props: {
    size: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      lclAlertTable: [{
        dtwin: 'Raum 191: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }, {
        dtwin: 'Raum 177: 27°C',
        value: '28°C'
      }, {
        dtwin: 'Raum 003: 27°C',
        value: '26°C'
      }, {
        dtwin: 'Raum 142: 27°C',
        value: 'Raum 27°C'
      }, {
        dtwin: 'Raum 111: 27°C',
        value: '27°C'
      }]
    };
  },
  computed: {
    color() {
      return this.vuetifyColorHex();
    },
    drawSize() {
      return this.size ? `${this.size}px` : '100%';
    },
    drawWidth() {
      return this.width ? `${this.width}px` : '100%';
    },
    drawBorder() {
      return this.border ? `1px solid ${this.color}` : 'none';
    }
  }
};